<template>
  <div class="nothing">
    <div class="notask">
      <img src="@/assets/image/found.png" alt="" />
    </div>
    <div class="gettask">暂无任务</div>
    <div class="gettask">
      <slot name="tip"> 您可以去“任务中心”接收新任务 </slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.gettask {
  padding-bottom: 10px;
  text-align: center;
  color: #ccc;
  font-size: 14px;
}
.nothing {
  padding-top: 8vh;
}
.notask {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 60%;
  }
}
</style>